import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-aqar23-c5',
  templateUrl: './aqar23-c5.component.html',
  styleUrls: ['./aqar23-c5.component.scss']
})
export class Aqar23C5Component implements OnInit {
  @HostListener("click") onClick() {
    this.checkRoute();
  }
  fullWidth = false;
  showSideMenu = false;
  constructor() { }

  ngOnInit(): void {
    this.checkRoute();
  }

  splitUrl() {
    let url = location.pathname.split('/');
    if (url.length === 5 || (url.length === 6 && (url[5] === '5-1-1' || url[5] === '5-1-3'))) {
      this.showSideMenu = true;
      this.fullWidth = false;
    }
    else {
      this.showSideMenu = false;
      this.fullWidth = true;
    }
  }
  checkRoute() {
    setTimeout(() => {
      this.splitUrl();
    })
  }
}
